<template>
  <div>
    <section>
      <el-radio-group v-model="activeTab" size="medium" class="m-b-sm">
        <el-radio-button label="my">我发起的申诉</el-radio-button>
        <el-radio-button label="confirm">待我确认的申诉</el-radio-button>
      </el-radio-group>
    </section>

    <keep-alive>
      <my-tort-list v-if="activeTab === 'my'"></my-tort-list>
      <confirm-tort-list v-if="activeTab === 'confirm'"></confirm-tort-list>
    </keep-alive>
  </div>
</template>

<script>
import MyTortList from './components/MyTortList.vue'
import ConfirmTortList from './components/ConfirmTortList.vue'

export default {
  name: 'CpTortList',
  components: {
    MyTortList,
    ConfirmTortList
  },
  data() {
    return {
      activeTab: 'my'
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .el-table thead tr th.el-table__cell {
    padding: 14px 0;
    background-color: #F7F8FA;
    border-bottom: none;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.85);
    font-weight: normal;

    &:not(:last-child) .cell {
      border-right: 1px solid #eee;
    }
  }

  .el-table .cell .el-button {
    margin-left: 0;
    padding: 4px !important;
  }
}
</style>
